import { addDays, getDay, format } from "date-fns";
import { pt } from "date-fns/locale";
import { WEEK_DAY_SHORT_LABELS } from "../constants";

type DayInfo = {
    date: Date;
    dayOfMonth: number;
    weekDay: number;
    weekDayLabel: string;
    dateKey: string;
};

export const generateDaysArray = (startDate: Date, count: number): Array<DayInfo> => {
    const days: Array<DayInfo> = [];
    let currentDate = startDate;
    let addedDays = 0;

    while (addedDays < count) {
        const weekDay = getDay(currentDate);

        if (weekDay !== 0) {
            days.push({
                date: currentDate,
                dayOfMonth: currentDate.getDate(),
                weekDay,
                weekDayLabel: WEEK_DAY_SHORT_LABELS[weekDay],
                dateKey: format(currentDate, "yyyy-MM-dd"),
            });
            addedDays++;
        }

        currentDate = addDays(currentDate, 1);
    }

    return days;
};

export const formatMonthYear = (date: Date) => {
    return format(date, "MMMM yyyy", { locale: pt });
};

